import { render, staticRenderFns } from "./AiEventAlarmSet.vue?vue&type=template&id=01c1bff2&scoped=true"
import script from "./AiEventAlarmSet.vue?vue&type=script&lang=js"
export * from "./AiEventAlarmSet.vue?vue&type=script&lang=js"
import style0 from "./AiEventAlarmSet.vue?vue&type=style&index=0&id=01c1bff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c1bff2",
  null
  
)

export default component.exports